<script setup>
import NewRegistrationFormWizard from "../../wizards/registrationForm/NewRegistrationFormWizard.vue";
import DetailEditorLayout from "../../components/view-components/DetailEditorLayout.vue";
</script>

<template>
    <new-registration-form-wizard></new-registration-form-wizard>
</template>

<style scoped lang="scss">

</style>
